import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import MyCollapse from 'components/Collapse';
import { MyTableHeader } from 'components/MyTable';
import moment from 'moment';
import React from 'react';
import MyTable from 'v2/components/Shared/MyTable';
import MyTableBody from 'v2/components/Shared/MyTable/MyTableBody';
import MyTableCol from 'v2/components/Shared/MyTable/MyTableCol';
import MyTableRow from 'v2/components/Shared/MyTable/MyTableRow';
import { ShoppingPaymentStatusId, type ShoppingDelivery } from 'v2/interfaces/shopping';

import useStyle from '../styles';

const headers = [
  { title: '', ordering: false },
  { title: 'Fatura', ordering: false },
  { title: 'Parcela', ordering: false },
  { title: 'Vencimento', ordering: false },
  { title: 'Valor', numeric: true, ordering: false },
];
const BankSlipInstallment = ({ delivery }: { delivery: ShoppingDelivery }) => {
  const classes = useStyle();
  return (
    <MyCollapse title={`Boleto Parcelado (${delivery?.bankslip_installments?.total_cycles} parcelas)`} arrow>
      <MyTable responsive={false}>
        <MyTableHeader index={headers} />

        <MyTableBody>
          {delivery?.bankslip_installments?.installments?.map((installment) => (
            <MyTableRow key={installment.invoice_id}>
              <MyTableCol screenSizes={{ xs: 1, sm: 1 }} status>
                {installment.payment_status.id === ShoppingPaymentStatusId.ABERTA ? (
                  <Tooltip title={'Agendada'} placement='top'>
                    <div className={`${classes.tableStatus} ${'scheduled'}`} />
                  </Tooltip>
                ) : (
                  <Tooltip title={installment.payment_status.name} placement='top'>
                    <div className={`${classes.tableStatus} ${installment.payment_status.alias}`} />
                  </Tooltip>
                )}
              </MyTableCol>
              <MyTableCol screenSizes={{ xs: 3, sm: 3 }}>{installment.invoice_id}</MyTableCol>
              <MyTableCol screenSizes={{ xs: 3, sm: 3 }} centered>
                {installment.cycle}/{delivery.bankslip_installments.total_cycles}
              </MyTableCol>
              <MyTableCol screenSizes={{ xs: 3, sm: 3 }}>{moment(installment.due_date).format('DD/MM/YYYY')}</MyTableCol>
              <MyTableCol numeric screenSizes={{ xs: 2, sm: 2 }}>
                {installment.value.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: delivery.currency_code,
                })}
              </MyTableCol>
            </MyTableRow>
          ))}
        </MyTableBody>
      </MyTable>
    </MyCollapse>
  );
};

export default BankSlipInstallment;
